import {
  createBrowserRouter,
  createHashRouter,
  Navigate,
  type RouteObject,
} from 'react-router-dom';
import { STUDY_EXPERIENCE_LAB_PATHS } from './experienceLabs';
import { isLocalStudyExperience, isStudyStudentExperience } from './mode';
import { SampleStudentProfile } from './SampleStudentProfile';
import {
  StudyStudentExperienceLayout,
  StudyExperienceBoundaryPage,
} from './StudyStudentExperienceLayout';

/** Reuse the production Study route elements; keep experience navigation inside its own URL. */
export function studentExperienceRoutes(routes: RouteObject[]): RouteObject[] {
  const learn = routes.find((route) => route.path === '/learn');
  const study =
    learn?.children?.filter(
      (route) => route.path === 'study' || route.path?.startsWith('study/'),
    ) ?? [];
  if (!study.length) throw new Error('The student experience needs the canonical Study routes.');
  const labs = routes.filter((route) => STUDY_EXPERIENCE_LAB_PATHS.includes(route.path ?? ''));
  return [
    { path: '/', element: <Navigate to="/learn/study" replace /> },
    ...labs,
    {
      path: '/learn',
      element: <StudyStudentExperienceLayout />,
      children: [
        ...study,
        ...(isLocalStudyExperience()
          ? [
              { path: 'my', element: <SampleStudentProfile /> },
              { path: 'profile', element: <SampleStudentProfile /> },
            ]
          : []),
        { index: true, element: <Navigate to="/learn/study" replace /> },
        { path: '*', element: <StudyExperienceBoundaryPage /> },
      ],
    },
    { path: '*', element: <StudyExperienceBoundaryPage /> },
  ];
}
export function createStudyAwareRouter(
  routes: RouteObject[],
  options?: Parameters<typeof createBrowserRouter>[1],
) {
  return isStudyStudentExperience()
    ? createHashRouter(studentExperienceRoutes(routes), options)
    : createBrowserRouter(routes, options);
}
